import {AxiosResponse} from 'axios';
//api
import {orgAPI} from '@/core/api';
//types
import {
	IAttentionList,
	IOrganizationDashboardAuctionItemsResponse,
	IOrganizationDashboardCheckedInResponse,
	IOrganizationDashboardStatistics,
	IOrganizationDashboardTablesSoldResponse,
	IOrganizationDashboardUnknownGuestsResponse,
	IRequestWithPagination,
} from '../types';
//enum
import {API_URL} from '../enums/api-url.enum';
//constants
import {defaultPageSize} from '../constants';

class OrganizationDashboardService {
	static getDashboardStatistics = async (id: number): Promise<AxiosResponse<IOrganizationDashboardStatistics>> =>
		orgAPI.get(`${API_URL.DASHBOARD_STATISTICS}/${id}`);

	static getDashboardTablesSold = async ({
		eventId,
		page,
		sortColumn,
		isOrderDesc,
		searchName,
	}: IRequestWithPagination): Promise<AxiosResponse<IOrganizationDashboardTablesSoldResponse>> =>
		orgAPI.post(API_URL.DASHBOARD_TABLES_SOLD, {eventId, page, sortColumn, isOrderDesc, defaultPageSize, searchName});

	static getDashboardTablesSoldCsv = async (id: number): Promise<AxiosResponse<File>> =>
		orgAPI.get(`${API_URL.DASHBOARD_EXPORT_TABLES_SOLD}/${id}`);

	static getDashboardUnknownGuests = async ({
		eventId,
		page,
		sortColumn,
		isOrderDesc,
		searchName,
	}: IRequestWithPagination): Promise<AxiosResponse<IOrganizationDashboardUnknownGuestsResponse>> =>
		orgAPI.post(API_URL.DASHBOARD_UNKNOWN_GUESTS, {
			eventId,
			page,
			sortColumn,
			isOrderDesc,
			defaultPageSize,
			searchName,
		});

	static getDashboardUnknownGuestsCsv = async (id: number): Promise<AxiosResponse<File>> =>
		orgAPI.get(`${API_URL.DASHBOARD_EXPORT_UNKNOWN_GUESTS}/${id}`);

	static getDashboardAuctionItems = async ({
		eventId,
		page,
		sortColumn,
		isOrderDesc,
		searchName,
	}: IRequestWithPagination): Promise<AxiosResponse<IOrganizationDashboardAuctionItemsResponse>> =>
		orgAPI.post(API_URL.DASHBOARD_AUCTION_ITEMS, {eventId, page, sortColumn, isOrderDesc, defaultPageSize, searchName});

	static getDashboardAuctionItemsCsv = async (id: number): Promise<AxiosResponse<File>> =>
		orgAPI.get(`${API_URL.DASHBOARD_EXPORT_AUCTION_ITEMS}/${id}`);

	static getDashboardCheckedIn = async ({
		eventId,
		page,
		sortColumn,
		isOrderDesc,
		searchName,
	}: IRequestWithPagination): Promise<AxiosResponse<IOrganizationDashboardCheckedInResponse>> =>
		orgAPI.post(API_URL.DASHBOARD_CHECKED_IN, {eventId, page, sortColumn, isOrderDesc, defaultPageSize, searchName});

	static getDashboardCheckedInCsv = async (id: number): Promise<AxiosResponse<File>> =>
		orgAPI.get(`${API_URL.DASHBOARD_EXPORT_CHECKED_IN}/${id}`);

	static getDashboardSpecialMeals = async ({
		eventId,
		page,
		sortColumn,
		isOrderDesc,
		searchName,
	}: IRequestWithPagination): Promise<AxiosResponse<IOrganizationDashboardCheckedInResponse>> =>
		orgAPI.post(API_URL.DASHBOARD_SPECIAL_MEALS, {eventId, page, sortColumn, isOrderDesc, defaultPageSize, searchName});

	static getDashboardSpecialMealsCsv = async (id: number): Promise<AxiosResponse<File>> =>
		orgAPI.get(`${API_URL.DASHBOARD_EXPORT_SPECIAL_MEALS}/${id}`);

	static getDashboardAttentionList = async ({
		organizationId,
		eventId,
	}: {
		organizationId: number;
		eventId: number;
	}): Promise<AxiosResponse<IAttentionList>> =>
		orgAPI.get(`${API_URL.DASHBOARD_ATTENTION}/${organizationId}?eventId=${eventId}`);

	static ignoreDashboardAttentionItem = async ({
		organizationId,
		attentionId,
	}: {
		organizationId: number;
		attentionId: number;
	}): Promise<AxiosResponse> => orgAPI.put(`${API_URL.DASHBOARD_ATTENTION}/${organizationId}/${attentionId}/ignore`);
}

export {OrganizationDashboardService};
